module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tjhzs-news tjhzs-main-content"
  }, [_c('router-link', {
    staticClass: "return_list",
    attrs: {
      "to": "/news_list"
    }
  }, [_vm._v("返回新闻列表")]), _vm._v(" "), _c('header', [_c('h3', [_vm._v(_vm._s(_vm.news.title))]), _vm._v(" "), _c('span', {
    staticClass: "news_time"
  }, [_vm._v("编写时间：" + _vm._s(_vm.news.createdate ? _vm.news.createdate : _vm.news.date))])]), _vm._v(" "), _c('section', {
    staticClass: "img-group"
  }, [(_vm.images.length > 0) ? _c('display-img', {
    attrs: {
      "isLink": false,
      "images": _vm.images,
      "size": _vm.size
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('section', {
    staticClass: "news-content",
    domProps: {
      "innerHTML": _vm._s(_vm.getHtml(_vm.news.content))
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1cd45a6e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/news.vue
// module id = 167
// module chunks = 1